export default "dist/images/block-button-fullwidth.efc38a4.png";